import React, { Component } from 'react';
import { Table } from 'antd';

import MachineDiagramsAddContainer from '../containers/MachineDiagramsAddContainer';

class DiagramsView extends Component {
    render() {
        const columns = [
            {
                title: 'Type',
                dataIndex: 'type',
                key: 'type',
            },
            {
                title: 'Detail',
                dataIndex: 'details',
                key: 'details',
            },
            {
                title: 'Author',
                dataIndex: 'author',
                key: 'author',
            },

        ];
        return (
            <div>
                <Table
                    dataSource={this.props.diagrams}
                    columns={columns}
                    expandedRowRender={record => (
                        <div>
                            <p style={{ margin: 0 }}>
                                {record.details}
                            </p>
                            { record.file != null && (
                                <a target="_blank" rel="noopener noreferrer" href={record.file}>
                                    Download File
                                </a>
                            )}
                        </div>
                    )}
                />
                <MachineDiagramsAddContainer
                    user={this.props.user}
                    extraUser={this.props.extraUser}
                />
            </div>
        );
    }
}

export default DiagramsView;



// WEBPACK FOOTER //
// ./src/components/views/DiagramsView.js